"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const profileSlice_1 = require("../../../../redux/slices/profileSlice");
const avatarApload_1 = __importDefault(require("../../../../shared/components/avatarApload/avatarApload"));
const svgIcons_1 = require("../../../../svgIcons");
const reviews_1 = __importDefault(require("../modals/reviews/reviews"));
const ratingIcon_1 = __importDefault(require("../../components/ratingIcon/ratingIcon"));
require("./user-info.scss");
const userSlice_1 = require("../../../../redux/slices/userSlice");
const profile_1 = require("../../../../shared/components/profile");
class UserInfo extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            reviewOpen: false
        };
        this.nameChange = (e, validate = false) => {
            var _a;
            const value = (_a = e.target) === null || _a === void 0 ? void 0 : _a.value;
            this.props.userFormChange({ value, field: 'name', validate });
        };
        this.toggleReview = () => {
            const { reviewOpen } = this.state;
            this.setState({ reviewOpen: !reviewOpen });
        };
    }
    render() {
        var _a, _b, _c, _d;
        const { edit = false, guest = false, user, profile: { userForm: { data: form } }, profile } = this.props;
        const { reviewOpen } = this.state;
        const currentUser = JSON.parse(localStorage.getItem('user'));
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement("div", { className: "user-info-box" },
                react_1.default.createElement(avatarApload_1.default, { user: user, avatarLoading: profile.avatarLoading, guest: guest, uploadAvatar: this.props.uploadAvatar, removeAvatar: this.props.removeAvatar }),
                !edit && react_1.default.createElement("div", { className: 'user-name' }, user.name),
                !guest && edit && react_1.default.createElement("div", null,
                    react_1.default.createElement(core_1.TextField, { fullWidth: true, "data-qa": 'user-name', value: ((_a = form === null || form === void 0 ? void 0 : form.name) === null || _a === void 0 ? void 0 : _a.value) || '', error: !!((_b = form === null || form === void 0 ? void 0 : form.name) === null || _b === void 0 ? void 0 : _b.error) && ((_c = form === null || form === void 0 ? void 0 : form.name) === null || _c === void 0 ? void 0 : _c.dirty), onChange: this.nameChange, onBlur: (e) => this.nameChange(e, true), placeholder: "Full Name", id: "fullName" })),
                user.linked_lf && !edit && react_1.default.createElement("a", { className: "profile-law-firm-name", href: `${((_d = currentUser.lawFirm) === null || _d === void 0 ? void 0 : _d.id) === user.linked_lf.id ? `#/law-firm/law-firm-profile?id=${user.linked_lf.id}` : `#/law-firm/law-firm-profile-guest?id=${user.linked_lf.id}`}` }, user.linked_lf.firm_name),
                user.roleId !== 9 && react_1.default.createElement(core_1.Box, null,
                    react_1.default.createElement("div", { className: `profile-rating-box ${edit ? 'disabled' : ""}` },
                        user.rate && user.rate != 0 ? react_1.default.createElement(lab_1.Rating, { name: "read-only", defaultValue: user.rate, precision: 0.5, size: "large", IconContainerComponent: (e) => {
                                return (react_1.default.createElement(ratingIcon_1.default, { props: e, rate: user.rate }));
                            }, readOnly: true }) : '',
                        user.rate == 0 && react_1.default.createElement(lab_1.Rating, { name: "read-only", defaultValue: 0, precision: 0.5, size: "large", icon: react_1.default.createElement(svgIcons_1.RatingStar, null), readOnly: true }),
                        user.rate != 0 && react_1.default.createElement("div", { className: "profile-rating-tot-num" }, user.rate)),
                    user.rate != 0 && user.ratesCount != '0' &&
                        react_1.default.createElement("div", { className: "out-of-review" },
                            "Out of ",
                            user.ratesCount,
                            " review",
                            user.ratesCount > 1 ? 's' : ''),
                    user.rate != 0 && !guest && react_1.default.createElement(react_1.Fragment, null,
                        react_1.default.createElement("a", { onClick: () => edit ? void (1) : this.toggleReview(), "data-qa": 'see-review', className: `profile-law-firm-name reviews ${edit ? 'disabled' : ""}` },
                            "See Review",
                            user.ratesCount > 1 ? 's' : ''),
                        reviewOpen && react_1.default.createElement(reviews_1.default, { cancelable: {
                                action: () => {
                                    this.setState({ reviewOpen: false });
                                }
                            }, open: reviewOpen }))),
                guest && react_1.default.createElement("a", { type: "button", className: "profile-call-button", href: `tel:${user.phone}` }, "Call"),
                user.roleId !== 9 && react_1.default.createElement(core_1.Box, { className: `activity-scores ${edit ? 'disabled' : ""}` },
                    react_1.default.createElement(profile_1.ActivityInfo, { title: 'Requests Submitted:', text: user.requests }),
                    user.access !== 2 && react_1.default.createElement(profile_1.ActivityInfo, { title: 'Requests Made:', text: user.acceptedCasesCount })))));
    }
}
const mapStateToProps = (state) => {
    const { user, profile } = state;
    return {
        user,
        profile
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        userFormChange: (data) => dispatch(profileSlice_1.userFormChange(data)),
        uploadAvatar: (data) => dispatch(userSlice_1.uploadAvatar(data)),
        removeAvatar: (data) => dispatch(userSlice_1.removeAvatar(data))
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(UserInfo);
